import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var DataRouting = require("lib/routing/DataRouting");
var QuestionTypes = require("lib/academic/QuestionTypes");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var AnswerDisplay = require("components/writing/answers/AnswerDisplay");
var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");

var TruncatedDataNote = require("components/data/TruncatedDataNote");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var EmptyState = require("components/data/EmptyState");
var Glyphicon = require("components/utility/icons/Glyphicon");

function propsToConditions(props) {
	var conditions = _.pick(props, 
		"startDate", "endDate", "textVariety", "textID", "userIDs", "order"
	);

	conditions.perPage = props.perPage || DataRouting.PER_PAGE;
	conditions.withTotal = true;

	return conditions;
}
// returns conditions for multiple requests
function largeRequestConditions(props) {
	return _.pick(props, "startDate", "endDate", "textVariety", "textID", "order");
}

function sortItems(answers) {
	return _.sortBy(answers, (x) => (new Date(x.completed_at)).valueOf()).reverse();
}
// determines if the request is large (requiring FE pagination)
// and returns data accordingly
function selectData(smallRequestFunction, largeRequestFunction, state, props) {
	if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
		return largeRequestFunction({ state, conditions: largeRequestConditions(props) });
	} else {
		var page = props.page || 1;
		return smallRequestFunction({ state, page, conditions: propsToConditions(props) });
	}
}
// returns correct total data
// large requests have all data saved in state
function getTotal(smallRequestFunction, state, props, answers) {
	if (props.userIDs && $wr.isLargeRequest(props.userIDs)) {
		return $wr.frontEndPaginationTotal(answers || state.answers);
	} else {
		return smallRequestFunction({ state, conditions: propsToConditions(props) })
	}
}

@connect(
	(state, props) => {
		if (props.answerType == PRACTICE_QUESTIONS) {
			var answers = selectData(WritingSelectors.nonQuizAnswersPaginated, WritingSelectors.nonQuizAnswers, state, props)
			var totalCount = getTotal(WritingSelectors.nonQuizAnswerTotal, state, props, _.where(state.answers, { question_type: QuestionTypes.GENERIC_QUESTION, quiz_id: null }))
			var displayText = "Practice Questions";
		} else if (props.answerType == REVIEWS) {
			var answers = selectData(WritingSelectors.reviewsPaginated, WritingSelectors.reviews, state, props)
			var totalCount = getTotal(WritingSelectors.reviewTotal, state, props, _.where(state.answers, { question_type: QuestionTypes.REVIEW_QUESTION }))
			var displayText = "Reviews";
		} else if (props.answerType == QUESTION_BUILDERS) {
			var answers = selectData(WritingSelectors.metaCognitiveAnswersPaginated, WritingSelectors.metaCognitiveAnswers, state, props)
			var totalCount = getTotal(WritingSelectors.metaCognitiveAnswerTotal, state, _.where(state.answers, { question_type: QuestionTypes.META_COGNITIVE_QUESTION }))
			var displayText = "Question Builders";
		} else {
			var answers = selectData(WritingSelectors.answersPaginated, WritingSelectors.answers, state, props)
			var totalCount = getTotal(WritingSelectors.answerTotal, state, props)
			var displayText = "Writing";
		}

		return {
			totalCount: totalCount,
			answers: sortItems(answers),
			loading: WritingSelectors.isLoadingAnswers({ state }),
			displayText: displayText,		
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			var conditions = propsToConditions(props);
			var page = props.page || 1;
			// TODO: standardize FE requests
			if (props.answerType == PRACTICE_QUESTIONS) {
				// if the dataset of students is large, send multiple requests
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order")
					var actionFunction = WritingActions.fetchNonQuizAnswers
					var options = {embeds: [ "answer.question", "answer.evaluation", "evaluation.score_details", "answer.meta_data"], cache: true}
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null)
				} else {
					return dispatch(WritingActions.fetchNonQuizAnswers({
						conditions,
						embeds: [
							"answer.question", "answer.evaluation", "evaluation.score_details",
							"answer.meta_data"
						],
						page,
						cache: true
					}));
				}
			} else if (props.answerType == REVIEWS) {
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order")
					var actionFunction = WritingActions.fetchReviews
					var options = { embeds: ["answer.meta_data"], cache: true }
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null)
				} else {
					return dispatch(WritingActions.fetchReviews({
						conditions,
						embeds: ["answer.meta_data"],
						page,
						cache: true
					}));
				}

			} else if (props.answerType == QUESTION_BUILDERS) {
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order")
					var actionFunction = WritingActions.fetchMetaCognitionAnswers
					var options = { embeds: ["answer.meta_data"], cache: true, page }
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null)
				} else {
					return dispatch(WritingActions.fetchMetaCognitionAnswers({
						conditions: conditions,
						embeds: ["answer.meta_data"],
						page,
						cache: true
					}));
				}

			} else {
				if ($wr.isLargeRequest(props.userIDs)) {
					var conditions = _.pick(props, "startDate", "endDate", "textVariety", "textID", "order")
					var actionFunction = WritingActions.fetchAnswers
					var options = { embeds: ["answer.question", "question.answer_options", "answer.evaluation", "evaluation.score_details", "answer.meta_data"], cache: true }
					$wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, null)
				} else {
					return dispatch(WritingActions.fetchAnswers({
						conditions,
						embeds: [
							"answer.question", "question.answer_options",
							"answer.evaluation", "evaluation.score_details",
							"answer.meta_data"
						],
						page,
						cache: true
					}));
				}
			}

		}
	})
)
@providePopulateData()
class DataAnswers extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { currentAnswerPage: 1 }

		LuckyOrangeClient.tagComponent("DataAnswers");
	}
	// FE pagination controlls for large requests
	onFrontendPaginationChange(page) {
		this.setState({ currentAnswerPage: page });
	}

	changeLocationState(quizID) {
		var newLocationState = { ...this.props.prevLocationState }
		this.props.updateRoute(newLocationState)
	}

	render() {
		var isAllWriting = this.props.answerType == ALL_ANSWERS;

		if (this.props.showFullData) {
			var answers = this.props.answers;
		} else {
			var answers = _.first(this.props.answers, 1);
			// var paywallDisplay = this.renderWritingPaywallDisplay();
		}

		if (this.props.fakePerPage) {
			answers = _.first(answers, this.props.fakePerPage)
		}

		if (this.props.loading) {
			var loadingDisplay = <Spinner />
		} else {
			if (answers.length > 0) {
				var answerDisplays = _.map(answers, (answer) => {
					var userID = answer.user_id;

					var enabled = { ...this.props.enabled };

					var isReview = answer.question_type == QuestionTypes.REVIEW_QUESTION;
					var forQuiz = answer.quiz_id != undefined;

					if (isReview) {
						delete enabled.score;
					}
					if (forQuiz) {
						delete enabled.score;
						delete enabled.editControls;
						delete enabled.allowRevision;
					}

					var view = isReview ? AnswerDisplay.REVIEWS_VIEW : AnswerDisplay.ANSWERS_VIEW;

					return (
						<AnswerDisplay answerID={ answer.id } key={ answer.id }
							enabled={ enabled } view={ view } />
					);
				});
				if (!this.props.showFullData) {
					var truncatedRow = <TruncatedDataNote total={ this.props.answers.length } type={ PRACTICE_QUESTIONS.replace(/-/g, ' ') } />
				}
			} else {
				if (this.props.sketchEmptyState) {
					var emptyState = <EmptyState type={ PRACTICE_QUESTIONS } />
				} else {
					var noAnswers = <NoActivityBlock userIDs={ this.props.userIDs } contentType={ this.props.displayText } />
				}
			}
		}

		if (this.props.onPageChange && this.props.totalCount) {
			if (this.props.showFullData) {
				if (answerDisplays && $wr.isLargeRequest(this.props.userIDs)) {
					// chunck all quizzes for pagination
					answerDisplays = _.chunk(answerDisplays, this.props.perPage || DataRouting.PER_PAGE)[this.state.currentAnswerPage - 1]
					//	pagination control
					var pagination = (
						<PaginationControls page={this.state.currentAnswerPage}
							perPage={DataRouting.PER_PAGE}
							totalCount={this.props.totalCount}
							onPageChange={this.onFrontendPaginationChange} />
					);
				} else {
					var pagination = (
						<PaginationControls page={this.props.page || 1}
							perPage={this.props.perPage || DataRouting.PER_PAGE}
							perPageOptions={PaginationControls.DEFAULT_PAGE_OPTIONS}
							totalCount={this.props.totalCount}
							onPageChange={this.props.onPageChange} />
					);
				}
			}
		}

		return (
			<div className="dataAnswers">
				{ pagination }
				{ emptyState }
				{ noAnswers }
				{ loadingDisplay }
				{ answerDisplays }
				{ truncatedRow }
				{ pagination }
			</div>
		)
	}
}

DataAnswers.defaultProps = {
	enabled: {}
}

DataAnswers.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from above
	userIDs: PropTypes.array,
	page: PropTypes.number,
	perPage: PropTypes.number,
	fakePerPage: PropTypes.number,
	order: PropTypes.string,
	startDate: PropTypes.string, 
	endDate: PropTypes.string, 
	textVariety: PropTypes.string,
	textID: PropTypes.string,
	showFullData: PropTypes.bool,
	answerType: PropTypes.string,
	onPageChange: PropTypes.func,
	showOnDashboard: PropTypes.bool,
	displayText: PropTypes.string,
	sketchEmptyState: PropTypes.bool,
	studentList: PropTypes.string,
	currentAnswerPage: PropTypes.number,
	prevLocationState: PropTypes.object,
	updateRoute: PropTypes.func,

	// Reference AnswerDisplay 'enabled'
	enabled: PropTypes.object,

	// Data from @connect
	loading: PropTypes.bool,
	answers: PropTypes.array,
	totalCount: PropTypes.number,

	// Handlers from @connect
	populateData: PropTypes.func,
})
var PRACTICE_QUESTIONS = "practice-questions";
var REVIEWS = "reviews";
var ALL_ANSWERS = "all-answers";
var QUESTION_BUILDERS = "Question Builders";

DataAnswers.PRACTICE_QUESTIONS = PRACTICE_QUESTIONS;
DataAnswers.REVIEWS = REVIEWS;
DataAnswers.QUESTION_BUILDERS = QUESTION_BUILDERS;
DataAnswers.ALL_ANSWERS = ALL_ANSWERS;

DataAnswers.ANSWER_TYPE_LOOKUP = {
	[DataRouting.SUBJECT_ANSWERS]: PRACTICE_QUESTIONS,
	[DataRouting.SUBJECT_REVIEWS]: REVIEWS,
	[DataRouting.SUBJECT_QUESTION_BUILDERS]: QUESTION_BUILDERS,
	[DataRouting.SUBJECT_WRITING]: ALL_ANSWERS
}

module.exports = DataAnswers;


// WEBPACK FOOTER //
// ./modules/components/data/subjects/DataAnswers.js